export enum CurrencyDefaultPaymentMethodsStaticActionType {
  Delete = 'delete',
}
